import React from 'react';
import styles from './Dashboard.module.css';

export default function LiveInfoCards({ data }) {
  return (
    <div className={styles.liveInfoSection}>
      <div className={styles.liveBadge}>LIVE</div>
      <div className={styles.liveInfoCards}>
        <div className={styles.liveCard}>
          <span className={styles.liveLabel}>Available Operators</span>
          <span className={styles.liveValue}>{data.loggedOnOps}</span>
        </div>
        <div className={styles.liveCard}>
          <span className={styles.liveLabel}>Logged-In Operators</span>
          <span className={styles.liveValue}>{data.onlineOperators ?? 0}</span>
        </div>
        <div className={styles.liveCard}>
          <span className={styles.liveLabel}>Messages In Queue</span>
          <span className={styles.liveValue}>{data.messagesInQueue}</span>
        </div>
        <div className={styles.liveCard}>
          <span className={styles.liveLabel}>Overdue Replies</span>
          <span className={`${styles.liveValue} ${styles.overdueValue}`}>{data.overdueReplies}</span>
        </div>
      </div>
    </div>
  );
} 